import styled from 'styled-components';

import MainHeader from 'components/MainHeader';

export const HomeHeader = styled(MainHeader)`
  font-size: 32px;
`;

export const HomeSectionHeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HomeSectionHeader = styled.h2`
  display: flex;
  flex: 1;
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.15px;
`;

export const ViewAllButtonLink = styled.a`
  text-decoration: none;
`;
